import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ButtonWithIcon } from '@els/els-react--button';

function SortingButtons(props) {
  const { onAscending, onDescending, disableAscending, disableDescending } = props;
  return (
    <section className="u-els-margin-left">
      <ButtonWithIcon
        sprite="ArrowDown"
        iconOnly
        type="link"
        onClick={onDescending}
        className={classnames('sort-descending', {
          'sort-descending-active': disableDescending,
        })}>
        Sort descending
      </ButtonWithIcon>
      <ButtonWithIcon
        sprite="ArrowUp"
        iconOnly
        type="link"
        onClick={onAscending}
        className={classnames('sort-ascending', {
          'sort-ascending-active': disableAscending,
        })}>
        Sort ascending
      </ButtonWithIcon>
    </section>
  );
}

SortingButtons.propTypes = {
  onAscending: PropTypes.func.isRequired,
  onDescending: PropTypes.func.isRequired,
  disableAscending: PropTypes.bool.isRequired,
  disableDescending: PropTypes.bool.isRequired,
};

export default SortingButtons;
